// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  /*THESE DON'T SEEM NEEDED...*/
  /*.select-icon-inner {
      background-color: var(--ion-color-primary);
      color: #ff0;
  }

  .select-icon {
      color: #fff;

  }

  .select-md {
      color: #fff;
  }*/
  /*.bbottomp {
      position: absolute;
  }*/
}
:host div.small {
  font-size: 14px;
  text-align: center;
}
:host .header:not(:last-child) {
  margin-right: 3px;
}
:host .header {
  /*margin-left: 10px;*/
  /*font-weight: bold;*/
  text-align: left;
  padding-left: 10px;
  height: 2.5em;
  vertical-align: middle;
  background-color: var(--ion-color-primary);
}
:host .header-active {
  /*font-weight: bold;*/
  text-align: left;
  padding-left: 10px;
  height: 2.5em;
  vertical-align: middle;
  background-color: var(--ion-color-secondary);
  color: #fff;
}
:host .header-active:not(:last-child) {
  margin-right: 3px;
}
:host #myrating, :host #avgrating {
  text-align: left;
  margin-left: 10px;
}
:host .subheader {
  font-size: 0.8em;
  margin-left: 10px;
}
:host .subheaderinactive {
  font-size: 0.8em;
  margin-left: 10px;
}
:host .subheaderactive {
  font-size: 0.8em;
  margin-left: 10px;
  font-weight: bold;
  color: var(--ion-color-primary);
}
:host #yellowactive {
  height: 3px;
  background-color: #fff;
}
:host ion-row.yellowruler {
  height: 2px;
  background-color: var(--ion-color-primary);
  width: 100%;
}
:host div.subactive {
  /*background-color: #00FF00;*/
}
:host div.subinactive {
  background-color: #f00;
}
:host ion-col.empty {
  background-color: #FFF;
}
:host ion-col.active {
  background-color: var(--ion-color-primary);
}
:host .itemshow {
  visibility: visible;
}
:host .itemhide {
  visibility: hidden;
}
:host .yellowBrown {
  background-color: var(--ion-color-primary);
  color: var(--ion-color-secondary);
  font-size: 13px;
  /* 1. Override the default 56px height */
  --min-height: 35px;
  min-height: 35px;
  /* 2. Remove default internal padding */
  --padding-top: 0;
  --padding-bottom: 0;
  /* 3. Ensure the item it sits in (if any) doesn't force it open */
  margin-top: 0;
  margin-bottom: 0;
}
:host .stickToBottom {
  position: sticky;
  bottom: 0;
  width: 100%;
}
:host #save {
  position: fixed;
  bottom: 50px;
  right: 10px;
}
:host .center {
  text-align: center;
}
:host #groups .item-md {
  padding-left: 0px;
}
:host #groups div.input-wrapper {
  background-color: var(--ion-color-primary);
}
:host #groups2 {
  background-color: var(--ion-color-primary);
}
:host div.item-inner {
  padding-right: 20px;
}
:host div.select-icon {
  background-color: var(--ion-color-primary);
}
:host div.select-text {
  background-color: var(--ion-color-primary);
}
:host .select-md .select-icon .select-icon-inner {
  color: var(--ion-color-secondary);
  background-color: var(--ion-color-primary);
}
:host .item-md.item-block .item-inner {
  padding-right: 0px;
}
:host .list-md {
  margin-top: 0px;
}
:host .item-input .label-md, :host .item-select .label-md, :host .item-datetime .label-md {
  color: var(--ion-color-secondary);
}
:host button.action-sheet-button span {
  color: #ff0;
}
:host .action-sheet-md {
  text-decoration: underline;
}
:host div#groupdummy {
  background-color: #fff;
  height: 31px;
}
:host .bottomparent .bottomchild {
  position: absolute;
  bottom: 0;
  left: 0px;
}
:host ion-grid {
  padding: 0;
}
:host ion-grid #groups {
  /*position: -webkit-sticky;*/
  position: fixed;
  /*position: sticky;*/
  bottom: 0;
  width: 100%;
}
:host ion-row#groups {
  /*height: 40px;*/
  background-color: var(--ion-color-primary);
}
:host ion-row#groups ion-col {
  background-color: var(--ion-color-primary);
}
:host div img {
  /*left: 50%;
  margin-left: -25px;
  position: relative;*/
  display: inline-block;
}
:host #my, :host #group, :host #similar {
  padding-bottom: 40px;
  margin: 0;
}
:host div.center {
  text-align: center;
  width: 100%;
}
:host rating-bar {
  display: inline-block;
  text-align: center;
}
:host rating-bar.center div {
  text-align: center;
}
:host rating-bar.left div {
  text-align: left;
}
:host ion-list {
  display: inline;
}
:host #dummywhitespace {
  height: 60px;
}
:host .list-ios > .item-block:first-child {
  /*border-top: 0px;*/
}
:host .list-ios > .item-block:last-child {
  border-bottom: 0px;
}
:host ion-col rating-bar {
  text-align: center;
  width: 100%;
}
:host .item-ios {
  font-size: 1.3rem;
  background-color: transparent;
}
:host .item-md {
  font-size: 1.3rem;
}
:host .item-ios.item-block .item-inner {
  border-bottom: 0px;
}

.action-sheet-md .action-sheet-group .action-sheet-selected .button-inner {
  font-weight: bold;
  color: var(--ion-color-secondary);
}

.action-sheet-md .action-sheet-group .button-inner {
  color: var(--ion-color-secondary);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
